import { render } from "./ClemsStockList.vue?vue&type=template&id=807e66ce&scoped=true&bindings={\"clemsData\":\"data\",\"isLoading\":\"data\",\"tastybrandsItems\":\"data\",\"bakecraftersItems\":\"data\",\"jtmItems\":\"data\",\"wildMikeItems\":\"data\",\"goldcreekItems\":\"data\",\"columns\":\"data\",\"getClemsStockListData\":\"options\",\"generateMfgLists\":\"options\",\"processItems\":\"options\"}"
import script from "./ClemsStockList.vue?vue&type=script&lang=js"
export * from "./ClemsStockList.vue?vue&type=script&lang=js"

import "./ClemsStockList.vue?vue&type=style&index=0&id=807e66ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-807e66ce"

export default script